import { render, staticRenderFns } from "./FMD.vue?vue&type=template&id=08520504&scoped=true&"
import script from "./FMD.vue?vue&type=script&lang=js&"
export * from "./FMD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08520504",
  null
  
)

export default component.exports